import logoSvg from '../assets/ggpathos-logo.svg?raw';

// The official GGPathOS logo (STR-007 v2.0), inlined into the DOM rather than loaded via <img> so
// the page's Montserrat web font applies to the logo's descriptor text (an <img>-loaded SVG is
// isolated from page web fonts and would fall back). The SVG is a trusted local asset.
export function Brand() {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- React's required dangerouslySetInnerHTML key
  const markup = { __html: logoSvg };
  return (
    <div className="brand-logo" role="img" aria-label="GGPathOS" dangerouslySetInnerHTML={markup} />
  );
}
